<template>
  <div>
    <div v-show="showOrders">
      <div class="show_small tr-highlighted p-1 mb-4" v-if="ordersSummary.total_price">
        <p>
          <strong>{{
              (ordersSummary.total_price &&
                ordersSummary.total_price.toLocaleString("ru-RU")) ||
              0
            }}</strong>
          сумма
        </p>
        <p>
          <strong>{{
              (ordersSummary.total_salary &&
                ordersSummary.total_salary.toLocaleString("ru-RU")) ||
              0
            }}</strong>
          ЗП
        </p>
        <p>
          <strong>{{
              (ordersSummary.total_post &&
                ordersSummary.total_post.toLocaleString("ru-RU")) ||
              0
            }}</strong>
          почтовые р.
        </p>
        <p>
          <strong>{{
              (ordersSummary.total_pass &&
                ordersSummary.total_pass.toLocaleString("ru-RU")) ||
              0
            }}</strong>
          к сдаче
        </p>
      </div>

      <table v-if="orders.length" class="table table-sm table-hover">
        <thead>
        <tr>
          <th>Номер</th>
          <th v-if="!clearedView">Проект<br/>Бандероль</th>
          <th v-if="!clearedView">Препараты</th>
          <th class="minW-85">Сумма</th>
          <th>З/п</th>
          <th v-if="!clearedView">Почтовы р.</th>
          <th>К сдаче<br/>общее</th>
          <th v-if="cashOperate">К сдаче нал.</th>
          <th v-if="!clearedView && showOrdersCostPrice">EUR</th>
          <th v-if="!clearedView && showOrdersCostPrice">Себест.</th>
          <th v-if="!clearedView && showOrdersCostPrice">Прибыль</th>
          <th v-if="!clearedView">Адрес</th>
          <th v-if="!clearedView">Курьер</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="!clearedView && ordersSummary.total_price" class="tr-highlighted hide_small">
          <td colspan="3"></td>
          <td>{{ (ordersSummary.total_price && ordersSummary.total_price.toLocaleString("ru-RU")) || 0 }}</td>
          <td>{{ (ordersSummary.total_salary && ordersSummary.total_salary.toLocaleString("ru-RU")) || 0 }}</td>
          <td>{{ (ordersSummary.total_post && ordersSummary.total_post.toLocaleString("ru-RU")) || 0 }}</td>
          <td>{{ (ordersSummary.total_pass && ordersSummary.total_pass.toLocaleString("ru-RU")) || 0 }}</td>
          <td v-if="cashOperate">
            {{ (((ordersSummary.total_price - ordersSummary.total_salary) || 0) - prePaidSum).toLocaleString("ru-RU") }}
          </td>
          <td v-if="showOrdersCostPrice">
            {{ (ordersSummary.price_in_eur && ordersSummary.price_in_eur.toLocaleString("ru-RU")) || 0 }}
          </td>
          <td v-if="showOrdersCostPrice">
            {{ (ordersSummary.total_cost && ordersSummary.total_cost.toLocaleString("ru-RU")) || 0 }}
          </td>
          <td v-if="showOrdersCostPrice">
            {{ (ordersSummary.price_in_eur - ordersSummary.total_cost).toLocaleString("ru-RU") }}
          </td>
          <td colspan="10"></td>
        </tr>
        <tr
          v-for="order in orders"
          :key="order.id"
          v-if="(statuses || [3, 11]).includes(order.status)"
          v-bind:class="{
              inEncashment:
                encashmentDate && isBefore(order.report_date, encashmentDate)
            }"
        >
          <td>
            <template v-if="clearedView">
              {{ order.id }}
            </template>
            <template v-else>
              <a :href="`/orders/edit/${order.id}`">{{ order.id }}</a
              ><br/>
              <small>{{
                  moment(order.report_date, "DD.MM.YYYY HH:mm:ss")
                }}</small>
            </template>
          </td>
          <td v-if="!clearedView">
            <b>{{ $AllProjects[order.site_id].name }}</b>
            <p>{{ $AllCities[order.city_id] && $AllCities[order.city_id].name || order.city_id }}</p>
            <small>{{
                moment(order.delivery_date, "DD.MM.YYYY HH:mm")
              }}</small>
            <div v-html="printPostTrack(order)"></div>
          </td>
          <td v-if="!clearedView" v-html="printDrugs(order.details)"></td>
          <td class="hide_small">
            <template v-if="order.pay_method === 3">
              <p>{{ order.price }}</p>
              <p><span class="fs-14"><i class="icon-fa icon-fa-credit-card"/></span> {{ order.no_cash_price }}</p>
              <p v-if="order.no_cash_price < order.price">₽ {{ order.price - order.no_cash_price }}</p>
            </template>
            <template v-else>
              <p>{{ order.price }}</p>
            </template>
          </td>
          <td class="hide_small">{{ order.salary }}</td>
          <td class="hide_small">{{ order.post_expenses }}</td>
          <td class="hide_small">
            {{
              order.price -
              (+order.salary || 0) -
              (+order.post_expenses || 0)
            }}
          </td>
          <td v-if="cashOperate" class="hide_small">
            {{
              order.price -
              (+order.salary || 0) -
              (order.pay_method === 3 ? +order.no_cash_price : 0) -
              (+order.post_expenses || 0)
            }}
          </td>
          <td class="show_small price_details">
            <div>
              <p>
                <strong>{{ order.price.toLocaleString("ru-RU") }}</strong> -
                сумма
              </p>
              <p>
                <strong>{{
                    (order.salary || 0).toLocaleString("ru-RU")
                  }}</strong>
                - ЗП
              </p>
              <p>
                <strong>{{
                    (order.post_expenses || 0).toLocaleString("ru-RU")
                  }}</strong>
                - Почтовые р.
              </p>
              <p>
                <strong>{{
                    (
                      order.price -
                      (+order.salary || 0) -
                      (+order.post_expenses || 0)
                      - (order.pay_method === 3 ? order.no_cash_price : 0)
                    ).toLocaleString("ru-RU")
                  }}</strong>
                - к сдаче
              </p>
            </div>
          </td>
          <td v-if="!clearedView && showOrdersCostPrice">
            {{ (Math.round(order.price_in_eur * 100) / 100).toLocaleString('ru-RU') }}
          </td>
          <td v-if="!clearedView && showOrdersCostPrice">
            {{ (order.cost_price && order.cost_price.toLocaleString('ru-RU')) || 0 }}
          </td>
          <td v-if="!clearedView && showOrdersCostPrice">
            {{ (Math.round((order.price_in_eur - order.cost_price) * 100) / 100).toLocaleString('ru-RU') }}
          </td>
          <td v-if="!clearedView">{{ order.address }}
            <div v-if="showComment" class="text-muted">
              {{ order.reject_comment }}
            </div>
          </td>
          <td v-if="!clearedView">
            {{ runnerNames[order.runner_id] }}
          </td>
          <td>
            <span v-if="order.pay_method === 3" class="fs-14"><i
              class="icon-fa icon-fa-credit-card"/> <strong>{{ order.no_cash_price }}</strong></span>
          </td>
        </tr>
        <tr v-if="!clearedView && ordersSummary.total_price" class="tr-highlighted hide_small">
          <td colspan="3"></td>
          <td>{{ (ordersSummary.total_price && ordersSummary.total_price.toLocaleString("ru-RU")) || 0 }}</td>
          <td>{{ (ordersSummary.total_salary && ordersSummary.total_salary.toLocaleString("ru-RU")) || 0 }}</td>
          <td>{{ (ordersSummary.total_post && ordersSummary.total_post.toLocaleString("ru-RU")) || 0 }}</td>
          <td>{{ (ordersSummary.total_pass && ordersSummary.total_pass.toLocaleString("ru-RU")) || 0 }}</td>
          <td v-if="cashOperate">
            {{ (((ordersSummary.total_price - ordersSummary.total_salary) || 0) - prePaidSum).toLocaleString("ru-RU") }}
          </td>
          <td v-if="showOrdersCostPrice">
            {{ (ordersSummary.price_in_eur && ordersSummary.price_in_eur.toLocaleString("ru-RU")) || 0 }}
          </td>
          <td v-if="showOrdersCostPrice">
            {{ (ordersSummary.total_cost && ordersSummary.total_cost.toLocaleString("ru-RU")) || 0 }}
          </td>
          <td v-if="showOrdersCostPrice">
            {{ (ordersSummary.price_in_eur - ordersSummary.total_cost).toLocaleString("ru-RU") }}
          </td>
          <td colspan="10"></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: [
    "showOrders",
    "orders",
    'statuses',
    'showComment',
    "ordersSummary",
    "runnerNames",
    "encashmentDate",
    'currentRate',
    'showOrdersCostPrice'
  ],
  data() {
    return {
      cashOperate: true,
      clearedView: false,
      prePaidSum: 0,
    };
  },
  computed: {
    $AllProjects() {
      let projects = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return projects;
    },
    $AllCities() {
      let cities = this.$store.getters["platform/cities"];
      cities[0] = {id: 0, name: "Почтовые города", short_name: "Почта"};
      return cities;
    },
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
    $AllStores() {
      return this.$store.getters["platform/stores"];
    }
  },
  created() {
    this.ordersSummary.total_salary = this.orders.filter((o) => [3, 11].includes(o.status)).reduce((acc, o) => {
      acc += +(o.salary || 0);
      return acc;
    }, 0);
    this.prePaidSum = this.orders.reduce((acc, o) => {
      if (o.pay_method === 3) {
        acc += o.no_cash_price;
      }
      return acc;
    }, 0)
    if (this.orders[0] && this.orders[0].city_id === 0) {
      this.cashOperate = false;
    }
    this.orders.forEach((o, i) => {
      this.orders[i].price_in_eur = o.price * o.rate;
    })
  },
  methods: {
    printPostTrack(order) {
      let text = "";
      if (order.track_number) {
        // text += `<a target="_blank" href="http://zayavka.name/images/signs/banderol_${order.id}.jpg">${order.extra_options.post_track}</a>`;
        text += `<span>${order.track_number}`;
        text += `<a target="_blank" href="https://www.pochta.ru/tracking#${order.track_number}"><i class="icon-fa icon-fa-info-circle"></i></a></span>`;
      }
      return text;
    },
    printDrugs(details) {
      let text = "";
      details.forEach(d => {
        text +=
          '<div class="drug_price_details"><p>' +
          d.new_drug.title +
          " (" +
          d.new_drug.id +
          ")</p>";
        if (d.pack_set != 1) {
          let setPrice = d.price * d.pack_set;
          text +=
            "<p><strong>" +
            d.qty / d.pack_set +
            "</strong> (компл) * <strong>" +
            setPrice +
            "</strong></p>";
          text +=
            "<p><strong>" +
            d.qty +
            "</strong> завод упак. * <strong>" +
            d.price +
            '</strong> (<span class="trx7">' +
            Math.round(d.cost_price * 100) / 100 +
            "</span>)</p>";
        } else {
          text +=
            "<p><strong>x " +
            d.qty +
            "</strong> * <strong>" +
            d.price +
            '</strong> (<span class="trx7">' +
            Math.round(d.cost_price * 100) / 100 +
            "</span>)</p>";
        }
        text += "</div>";
      });
      return text;
    },
    moment: function (date, format) {
      if (!date) return;
      return moment(date).format(format);
    },
    isBefore(date1, date2) {
      return moment(date1).isBefore(date2);
    }
  }
};
</script>

<style scoped>
p {
  margin-bottom: 2px;
}

@media only screen and (max-width: 760px),
(min-device-width: 768px) and (max-device-width: 1024px) {
  /* Force table to not be like tables anymore */
  .show_small {
    display: block !important;
  }

  .price_details p {
    margin-bottom: 2px;
  }

  table.table .hide_small,
  table.table thead {
    display: none;
  }

  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  tr {
    margin-bottom: 10px;
    background-color: #f8f8f8;
  }

  td {
    /* Behave  like a "row" */
    /* border: none; */
    /* border-bottom: 1px solid #d4d4d4; */
    position: relative;
    padding-left: 30% !important;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 0;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    font-size: 12px;
  }

  td:nth-of-type(1):before {
    content: "Номер заявки,\Aдата отчета";
    white-space: pre;
  }

  td:nth-of-type(2):before {
    content: "Проект,\Aбандероль";
    white-space: pre;
  }

  td:nth-of-type(3):before {
    content: "Препараты";
  }

  td:nth-of-type(8):before {
    content: "Расчет";
  }

  td:nth-of-type(9):before {
    content: "Отчет";
  }

  td:nth-of-type(10):before {
    content: "Адрес";
  }

  td:nth-of-type(11):before {
    content: "Курьер";
  }
}

.show_small {
  display: none;
}

.inEncashment {
  background-color: #e9ffe9;
}

.tr-highlighted {
  font-weight: 600;
}

.minW-85 {
  min-width: 85px;
}
</style>
